<template lang="pug">
div
  IconBtn(title="Add", icon="mdi-plus", @click="handleEdit()")
  Table.my-5(@edit="handleEdit")
  Form(ref="form")
  BizServiceLoad
</template>

<script>
import Table from "./Table";
import Form from "./Form/index";
import { mapActions } from "vuex";

export default {
  components: { Table, Form },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions(["setBizServicePlans"]),
    handleEdit(item) {
      this.$refs.form.open(item);
    },
    async load() {
      const params = { criteria: {} };
      const result = await this.$api.service.plan.list(params);
      this.setBizServicePlans(result);
    },
  },
};
</script>